<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto" *ngIf="this.claimId">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                    [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Employer Selection</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="pages_space">
        <form name="addActivityForm" [formGroup]="addActivityForm">

            <section id="stage2" class="outline_emp" *ngIf="showStage1">
                <div class="row">
                    <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let employer of this.employmentListData">
                        <div class="card iQcard item-hover-effect card_employer">
                            <div class="iQcard_header">
                                <div class="row">
                                    <div class="col">
                                        <div class="date_digit">
                                            <k-icon [icon]="{type: 'kennedys', name: 'calendar'}"></k-icon>
                                            {{employer['employmentFrom'] | date:'dd/MM/yyyy'}} to
                                            {{employer['employmentTo']
                                            |
                                            date:'dd/MM/yyyy'}}
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="date_text">{{employer['employmentPeriod']}}</div>
                                    </div>
                                    <div class="col-auto pl-0">
                                        <ul class="card_more_dropdown float-right">
                                            <li>
                                                <a>
                                                    <k-icon class="kebab_menu"
                                                        [icon]="{type: 'image', src: './../assets/images/more.svg'}"></k-icon>
                                                </a>
                                                <ul>
                                                    <li (click)="editEmployer()">
                                                        Edit
                                                    </li>

                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="iQcard_body pt-0">

                                <div class="d-flex justify-content-end">
                                    <div class="form-check form-check-inline mr-0">
                                        <input type="radio" [id]="employer['employer']" formControlName="employerName"
                                            name="employerName" class="form-check-input me-1"
                                            (click)="onEmployerNameClick(employer)" [value]="employer['employer']">
                                        <label class="form-check-label" for="{{employer['employer']}}">
                                            <b>{{employer['employer']}}</b>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <div id="stage3" [class.hidden]="hideStage2">

                <section class="outline_activity">
                    <div class="row">
                        <div class="col-12">
                            <p><b>Activity Details</b></p>
                        </div>


                        <div class="col-7 mb-7">
                            <k-label [tooltipText]="'Task'" [helpText]="'Select Task'" for="dropdown"
                                [required]="true">Task</k-label>
                            <span title={{addActivityForm.controls.task.value}}>
                                <k-combobox class="comboboxInput" formControlName="task" [options]="taskList"
                                    [hideNoData]="comboboxHideNoData" [allowNewValues]="false"></k-combobox>
                            </span>
                            <div *ngIf="isSubmitted && f.task.errors">
                                <div *ngIf="isSubmitted && f.task.errors.required" class="errors_block">Task is required
                                </div>
                            </div>
                            <div *ngIf="isSubmitted && f.task.errors">
                                <div *ngIf="isSubmitted && f.task.errors.invalidTask" class="errors_block">Task must be
                                    selected from the dropdown</div>
                            </div>
                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Fibre Type'" [helpText]="'Select Fibre Type'" for="dropdown"
                                [required]="true">Fibre Type</k-label>
                            <k-dropdown formControlName="fibreType" name="dropdown" [options]="fibreTypes"></k-dropdown>
                            <div *ngIf="isSubmitted && f.fibreType.errors">
                                <div *ngIf="isSubmitted && f.fibreType.errors" class="errors_block"> Fibre Type is
                                    required </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="outline_time ">
                    <div class="row">
                        <div class="col-12">
                            <p><b>Time Details</b></p>
                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Date from'" [helpText]="'Select date from'" for="dropdown"
                                [required]="true">Date from</k-label>
                            <k-dynamic-input formControlName="dateFrom"
                                [inputType]="dynamicDateInput"></k-dynamic-input>
                            <div *ngIf="isSubmitted && f.dateFrom.errors">
                                <div *ngIf="isSubmitted && f.dateFrom.errors?.required" class="errors_block">Date from
                                    is required
                                </div>
                                <div *ngIf="isSubmitted && f.dateFrom.errors?.invalidDate" class="errors_block">' Date
                                    from' should be a date before the 'Date to'</div>
                            </div>
                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Date to'" [helpText]="'Select date to'" for="dropdown"
                                [required]="true">Date to</k-label>
                            <k-dynamic-input formControlName="dateTo" [inputType]="dynamicDateInput"></k-dynamic-input>
                            <div *ngIf="isSubmitted && f.dateTo.errors">
                                <div *ngIf="isSubmitted && f.dateTo.errors?.required" class="errors_block">Date to is
                                    required</div>
                                <div *ngIf="isSubmitted &&  f.dateTo.errors?.invalidDate" class="errors_block">' Date
                                    to' should be a date after the 'Date from'</div>
                            </div>

                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'mm exposed'" [helpText]="'mm exposed'" for="dropdown"
                                [required]="true">mm exposed</k-label>
                            <k-dynamic-input formControlName="mmExposed"
                                [inputType]="dynamicNumberInput"></k-dynamic-input>
                            <div *ngIf="isSubmitted && f.mmExposed.errors" class="errors_block">mm exposed is required
                                and cannot be zero</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Distance Correction'" [helpText]="'Select Distance Correction'"
                                for="dropdown" [required]="true">Distance Correction</k-label>
                            <k-dropdown formControlName="distanceCorrection" name="dropdown"
                                [options]="distanceCorrectionList"></k-dropdown>
                            <div *ngIf="isSubmitted && f.distanceCorrection.errors">
                                <div *ngIf="isSubmitted && f.distanceCorrection.errors" class="errors_block"> Distance
                                    Correction is required </div>
                            </div>
                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Range'" [helpText]="'Select Range'" for="dropdown"
                                [required]="true">Range</k-label>
                            <k-dropdown formControlName="range" name="dropdown" [options]="rangeList"></k-dropdown>
                            <div *ngIf="isSubmitted && f.range.errors">
                                <div *ngIf="isSubmitted && f.range.errors" class="errors_block"> Range is required
                                </div>
                            </div>
                        </div>

                        <div class="col-3 mb-3">
                            <k-label [tooltipText]="'Days'" [helpText]="'Days'" for="dropdown"
                                [required]="true">Days</k-label>
                            <k-dropdown formControlName="days" name="dropdown" [options]="daysList"></k-dropdown>
                            <div *ngIf="isSubmitted && f.days.errors" class="errors_block">Day(s) are required</div>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="row">
                        <div class="col-12 text-center">
                            <k-button [type]="KButtonType.KLAiMSButton" [label]="'Save'" [color]="'brand-main'"
                                (buttonClick)="saveAddActivityForm(addActivityForm)">
                            </k-button>
                        </div>
                    </div>
                </section>

            </div>

            <div id="stage4" [class.hidden]="hideStage4">
                <section>
                    <div class="row">
                        <div class="col-12">
                            <p>Dose Summary</p>
                        </div>


                    </div>
                </section>

                <br>

            </div>
        </form>
    </div>
</div>

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>